export const LARGE_DOWNLOAD_MESSAGES_COUNT = 15;
export const SMALL_DOWNLOAD_MESSAGES_COUNT = 10;
export const BOTH_DIRECTIONS_DOWNLOAD_MESSAGES_COUNT = 25;
